import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { RbacRoleEntity } from './rbac-role.entity';
import { WebsiteEntity } from './website.entity';

/**
 * What one of a brand's websites is allowed to do, granted as roles exactly the way
 * `_rbac_role__api_key` grants them to an API key.
 *
 * The grant sits on the WEBSITE, not on each address: a site accumulates addresses over the
 * years and nobody should maintain the same permissions once per address. Every address
 * linked to the website inherits these roles.
 *
 * Read this as a PUBLIC grant. A browser cannot lie about which site a request came from,
 * but a script can send whatever it likes, so anything granted here is in practice available
 * to an anonymous caller. Grant only what is safe on that basis — submitting a registration
 * is; reading a customer's invoices is not, and belongs behind a real credential.
 */
@Index('fk_website__id', ['fkWebsiteId'], {})
@Index('fk_rbac_role__id', ['fkRbacRoleId'], {})
@Index('unique_website_role', ['fkWebsiteId', 'fkRbacRoleId'], { unique: true })
@Entity('rbac_role__website')
export class RbacRoleWebsiteEntity extends BaseEntity {
	@Column('int', { name: 'fk_website__id', unsigned: true })
	public fkWebsiteId!: number;

	@Column('int', { name: 'fk__rbac_role__id', unsigned: true })
	public fkRbacRoleId!: number;

	@ManyToOne(() => WebsiteEntity, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_website__id', referencedColumnName: 'id' }])
	public website!: WebsiteEntity;

	@ManyToOne(() => RbacRoleEntity, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk__rbac_role__id', referencedColumnName: 'id' }])
	public rbacRole!: RbacRoleEntity;
}
